<template>
  <div class="notification">
    <div :class="indicatorClass(notification)" class="indicator" />
    <template v-if="notification[notification.kind]">
      {{ notification[notification.kind].contact.email }} <br >
    </template>
    <small>{{ $t('notification.added') }} {{ textNotification(notification.kind) }} {{ $t('notification.on_date') }}</small>
    <template v-if="notification.date">
      <small>{{ dateFormat(notification.date.date) }}</small>
    </template>
    <template v-else>
      <small>{{ dateFormat(notification.created_at) }}</small>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'OneNotificationComponent',
    props: {
      notification: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      indicatorClass(notification) {
        return !notification.read ? 'pending' : '';
      },
      textNotification(kind) {
        return this.$t(`notification.${kind}`);
      },
      dateFormat(date) {
        return this.$moment(date).format('LLL');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .notification {
    margin: 0;
    padding: 15px;
    border-radius: .25rem;
    cursor: pointer;

    &:hover {
      background-color: lighten($light-grey, 8);
    }
  }

  .indicator {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: none;

    &.pending {
      display: block;
      background-color: $red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/OneNotification.vue